'use client'

import { FC, PropsWithChildren } from 'react'
import { AriaRadioGroupProps, useRadioGroup } from 'react-aria'
import { RadioGroupState, useRadioGroupState } from 'react-stately'

import { createRequiredContext } from '../../utils/create-required-context'

const [useRadioGroupContext, RadioGroupContextProvider] =
  createRequiredContext<RadioGroupState>('RadioGroup')

export interface RadioGroupProps
  extends PropsWithChildren<AriaRadioGroupProps> {
  label?: string
  description?: string
  errorMessage?: string
  className?: string
}

const RadioGroup: FC<RadioGroupProps> = props => {
  const { children, className } = props
  const state = useRadioGroupState(props)
  // @TODO enhance this behavior to handle labelPops, descriptionProps and errorMessageProps
  const { radioGroupProps } = useRadioGroup(props, state)

  return (
    <div {...radioGroupProps} className={className}>
      <RadioGroupContextProvider value={state}>
        {children}
      </RadioGroupContextProvider>
    </div>
  )
}

export { RadioGroup, useRadioGroupContext }
